import type { Person } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/library'
import { labelFor, uploadImageCollections, ValidationError } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/library'
import { usePersonsStore } from '@/stores/persons'
import { useComponentsStore } from '@/stores/components'
import { useProtocolStore } from '@/stores/protocol'

export const validatePerson = async (person: Person, onBeforeUpload?: () => void, onAfterUpload?: (success: boolean) => void): Promise<boolean> => {
	const personsStore = usePersonsStore(),
		componentsStore = useComponentsStore(),
		protocolStore = useProtocolStore()
	
	const signatureComponents = componentsStore.by_tag['signature'],
		signatureComponent = signatureComponents[0] ?? null
	
	if (person.signature) {
		if (signatureComponent?.properties.contents_agreement_label && !person.content_agreed) {
			throw new ValidationError(
				labelFor(signatureComponent.validation_error_labels?.person_contents_agreement_missing, protocolStore.language, 'Contents have not been agreed to')!,
				signatureComponent,
				'content_agreed',
				{
					component_uid: signatureComponent.properties.uid,
					person_id: person.id,
				},
				Boolean(signatureComponent.validation_error_labels?.person_contents_agreement_missing)
			)
		}
		
		// Check for and upload documents
		if (signatureComponent && protocolStore.mustPersonProvideElectricityDocuments(person)) {
			if (!person.signature_documents?.length || !person.signature_documents[0].images.length) {
				throw new ValidationError(
					labelFor(signatureComponent.validation_error_labels?.person_signature_documents_missing, protocolStore.language, 'Identification document missing')!,
					signatureComponent,
					'documents',
					{
						component_uid: signatureComponent.properties.uid,
						person_id: person.id,
					},
					Boolean(signatureComponent.validation_error_labels?.person_signature_documents_missing)
				)
			}
			
			// Upload documents
			onBeforeUpload?.()
			
			const promises = uploadImageCollections(
				signatureComponent,
				null,
				{
					type: 'id'
				},
				person.signature_documents
			)
			
			try {
				await Promise.all(promises)
				onAfterUpload?.(true)
			} catch (e: any) {
				onAfterUpload?.(false)
				throw e
			}
		}
		
		personsStore.validatePerson(person)
		return true
	} else {
		if (signatureComponent) {
			throw new ValidationError(
				labelFor(signatureComponent.validation_error_labels?.person_signature_missing, protocolStore.language, 'Signature missing')!,
				signatureComponent,
				'signature',
				{
					component_uid: signatureComponent.properties.uid,
					person_id: person.id,
				},
				Boolean(signatureComponent.validation_error_labels?.person_signature_missing),
			)
		} else {
			throw new Error('Signature missing for ' + person.id)
		}
	}
}

